export const KIOSK_CREDENTIALS_QR_VERSION = 1;

interface KioskCredentialsQrPayload {
  type: "kiosk_credentials";
  v: number;
  identifier: string;
  password: string;
}

export function buildKioskCredentialsQrValue(
  identifier: string,
  password: string,
): string {
  const payload: KioskCredentialsQrPayload = {
    type: "kiosk_credentials",
    v: KIOSK_CREDENTIALS_QR_VERSION,
    identifier,
    password,
  };

  return JSON.stringify(payload);
}
